import styled from "styled-components";

export const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	width: 100%;
`;

export const TextMessageError = styled.p`
	position: absolute;
	bottom: -1.2rem;
	left: 0;
	margin: 0;
	font-size: 0.8rem;
	color: ${({ theme }) => theme.red};
`;

export const InpuTWithSuffix = styled.div`
	position: relative;
	width: 100%;
`;
